export enum CartIoDirection {
    Import = 'import',
    Export = 'export',
}